/**
 * Wartet bis TaxReportPrint fertig gerendert ist (data-v3tax-print-ready="1").
 * Fallback: timeout → trotzdem drucken.
 */
export function waitForPrintReady({
  rootId = "tax-report-print-root",
  timeoutMs = 15000,
  minWaitMs = 80,
} = {}) {
  return new Promise((resolve) => {
    const started = performance.now();
    let sawRoot = false;

    const tick = () => {
      const root = document.getElementById(rootId);
      if (root) sawRoot = true;

      const elapsed = performance.now() - started;
      const ready = root?.getAttribute("data-v3tax-print-ready") === "1";

      if (ready && elapsed >= minWaitMs) {
        resolve(true);
        return;
      }

      if (elapsed >= timeoutMs) {
        resolve(false);
        return;
      }

      // Root noch nicht gemountet → weiter warten
      if (!sawRoot && elapsed < timeoutMs) {
        requestAnimationFrame(tick);
        return;
      }

      requestAnimationFrame(tick);
    };

    requestAnimationFrame(tick);
  });
}
